import { MenuItem, NebulaNavigationService } from 'nebula-ui-kit';
import { detectLayoutModule, findTabByNormalizedRoute, isAtOpenTabLimit } from './tab-limit-util';

let installed = false;
let origCloseTab: ((id: string | number) => void) | null = null;
const swallowKitCloseIds = new Set<string>();

/**
 * El kit llama addTabFromMenu despues del itemClick. Solo se corta el alta al tope;
 * la ruta del menu se deja igual (sin lowercase) para que el router no se vaya a Contabilidad.
 *
 * El kit tambien llama closeTab justo despues de emitir onClose (aunque syncWithService=false).
 * Ese close se traga para que el ERP confirme dirty y navegue dentro del mismo modulo.
 */
export function installOpenTabLimit(nav: NebulaNavigationService): void {
  if (installed) return;
  installed = true;

  const origAdd = nav.addTabFromMenu.bind(nav);
  origCloseTab = nav.closeTab.bind(nav);

  nav.addTabFromMenu = (item: MenuItem) => {
    const route = item?.route;
    if (!route) return;

    const existing = findTabByNormalizedRoute(nav.tabs(), route);
    if (existing?.route) {
      origAdd({ ...item, route: existing.route });
      return;
    }

    if (isAtOpenTabLimit(nav.tabs(), detectLayoutModule(route))) {
      return;
    }

    origAdd(item);
  };

  nav.closeTab = (id: string | number) => {
    const key = String(id);
    if (swallowKitCloseIds.has(key)) {
      swallowKitCloseIds.delete(key);
      return;
    }
    origCloseTab?.(id);
  };
}

/** El siguiente closeTab del kit para este id no cierra (lo maneja onClose del ERP). */
export function swallowNextKitClose(id: string | number): void {
  swallowKitCloseIds.add(String(id));
  queueMicrotask(() => swallowKitCloseIds.delete(String(id)));
}

/** Cierra de verdad, sin pasar por el wrap que traga el close del kit. */
export function forceCloseTab(nav: NebulaNavigationService, id: string | number): void {
  if (origCloseTab) {
    origCloseTab(id);
    return;
  }
  nav.closeTab(id);
}

/** Solo tests: permite reinstalar el wrap sobre otro mock. */
export function resetOpenTabLimitForTests(): void {
  installed = false;
  origCloseTab = null;
  swallowKitCloseIds.clear();
}
